/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import AdminAction from './AdminAction/index'
import ApplicationsAction from './ApplicationsAction/index'
import ChairsAction from './ChairsAction/index'
import DocumentTemplatesAction from './DocumentTemplatesAction/index'
import DocumentTemplatesOldAction from './DocumentTemplatesOldAction/index'
import FeatureFlagsAction from './FeatureFlagsAction/index'
import HrAdminAction from './HrAdminAction/index'
import MedicalFormAction from './MedicalFormAction/index'
import MedicalHistoryAction from './MedicalHistoryAction/index'
import NoteTemplatesAction from './NoteTemplatesAction/index'
import NpsAction from './NpsAction/index'
import PatientHubAction from './PatientHubAction/index'
import PaymentProviderAction from './PaymentProviderAction/index'
import PhoneNumbersAction from './PhoneNumbersAction/index'
import React from 'react'
import SecureValueAction from './SecureValueAction/index'
import SupportOnly from 'DesignSystem/SupportOnly/index'
import TracedCephsAction from './TracedCephsAction/index'
import TreatmentAutomationsAction from './TreatmentAutomationsAction/index'
import TreatmentCardAction from './TreatmentCardAction/index'
import TreatmentPaymentPlansAction from './TreatmentPaymentPlansAction/index'
import TreatmentPlanTemplatesAction from './TreatmentPlanTemplatesAction/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaIconSidebarClose from 'DesignSystem/Svgs/TysiaIconSidebarClose/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/Menu/Content"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 size="small"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../No'))}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconSidebarClose
{...childProps}
  viewPath={`${viewPath}/TysiaIconSidebarClose`}
 fill="white"
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 marginLeft={dtSpaceXs}
 text="Close"
/>
</React.Fragment>
)}
</TysiaButton>
</div>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={dtSpaceS}
 marginLeft={dtSpaceXxs}
 level="h3"
 text="Comms"
/>
<PhoneNumbersAction
  viewPath={`${viewPath}/PhoneNumbersAction`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Images"
/>
<TracedCephsAction
  viewPath={`${viewPath}/TracedCephsAction`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Medical"
/>
<MedicalHistoryAction
  viewPath={`${viewPath}/MedicalHistoryAction`}
/>
<MedicalFormAction
  viewPath={`${viewPath}/MedicalFormAction`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Outreach"
/>
<NpsAction
  viewPath={`${viewPath}/NpsAction`}
/>
<PatientHubAction
  viewPath={`${viewPath}/PatientHubAction`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Templates"
/>
<DocumentTemplatesOldAction
  viewPath={`${viewPath}/DocumentTemplatesOldAction`}
/>
<SupportOnly
  viewPath={`${viewPath}/SupportOnly`}
>
{childProps => (
<React.Fragment>
<DocumentTemplatesAction
{...childProps}
  viewPath={`${viewPath}/DocumentTemplatesAction`}
/>
<NoteTemplatesAction
{...childProps}
  viewPath={`${viewPath}/NoteTemplatesAction`}
/>
</React.Fragment>
)}
</SupportOnly>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Treatment"
/>
<TreatmentAutomationsAction
  viewPath={`${viewPath}/TreatmentAutomationsAction`}
/>
<TreatmentCardAction
  viewPath={`${viewPath}/TreatmentCardAction`}
/>
<TreatmentPlanTemplatesAction
  viewPath={`${viewPath}/TreatmentPlanTemplatesAction`}
/>
<TreatmentPaymentPlansAction
  viewPath={`${viewPath}/TreatmentPaymentPlansAction`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Scheduling"
/>
<ChairsAction
  viewPath={`${viewPath}/ChairsAction`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="General"
/>
<AdminAction
  viewPath={`${viewPath}/AdminAction`}
/>
<HrAdminAction
  viewPath={`${viewPath}/HrAdminAction`}
/>
<FeatureFlagsAction
  viewPath={`${viewPath}/FeatureFlagsAction`}
/>
<SecureValueAction
  viewPath={`${viewPath}/SecureValueAction`}
/>
<ApplicationsAction
  viewPath={`${viewPath}/ApplicationsAction`}
/>
<SupportOnly
  viewPath={`${viewPath}/SupportOnly`}
>
{childProps => (
<React.Fragment>
<TysiaHeading
{...childProps}
  viewPath={`${viewPath}/TysiaHeading`}
 marginLeft={dtSpaceXxs}
 marginTop={dtSpaceM}
 level="h3"
 text="Payments"
/>
<PaymentProviderAction
{...childProps}
  viewPath={`${viewPath}/PaymentProviderAction`}
/>
</React.Fragment>
)}
</SupportOnly>
</div>
{children}
</React.Fragment>)
}